import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useCompanyType from "../hooks/useCompanyType";
import useDefaultRedirect from "../../account/hooks/useDefaultRedirect";

interface TypeGuardProps {
  requiredType: "operator" | "provider";
}

const TypeGuard = ({ requiredType }: TypeGuardProps) => {
  const { companyType, isOperator, isProvider } = useCompanyType();
  const { defaultRoute } = useDefaultRedirect();

  // Legacy/unknown company type -- allow everything
  if (companyType === 0) {
    return <Outlet />;
  }

  const hasAccess =
    requiredType === "operator" ? isOperator : isProvider;

  if (hasAccess) {
    return <Outlet />;
  }

  return <Navigate to={defaultRoute()} replace />;
};

export default TypeGuard;
